import { ChakraFlex, FAIconName, Icon, Text } from '@equip.health/ui';
import { CarePlanNoteInterventionResponse } from '~/lib/types/carePlan/carePlans';
import { ReactNode } from 'react';
import { InterventionText } from '../careplan/InterventionText';
import { useGetInterventionCategoriesEnumQuery } from '~/store/services/refCarePlanEnums';

type Props = {
  intervention: CarePlanNoteInterventionResponse;
};
export const PatientNoteItemInterventionRow = ({ intervention }: Props) => {
  const { data: categories } = useGetInterventionCategoriesEnumQuery();
  const earliestStatusHistory = intervention.statusHistories.at(-1);

  let statusNode: ReactNode;
  if (intervention.statusHistories.length === 0) {
    // unexpected case, default to status value
    statusNode = (
      <Text
        variant="caption"
        whiteSpace="nowrap"
        data-testid={`patient-note-item__intervention-status__${intervention.id}`}
      >
        {intervention.status.label}
      </Text>
    );
  } else if (
    earliestStatusHistory.statusTo.code ===
    intervention.statusHistories[0].statusTo.code
  ) {
    statusNode = (
      <Text
        variant="caption"
        whiteSpace="nowrap"
        data-testid={`patient-note-item__intervention-status__${intervention.id}`}
      >
        {intervention.statusHistories[0].statusTo.label}
      </Text>
    );
  } else {
    statusNode = (
      <ChakraFlex
        gap="12px"
        alignItems="center"
        data-testid={`patient-note-item__intervention-status__${intervention.id}`}
      >
        <Text variant="caption" color="neutral.secondary" whiteSpace="nowrap">
          {earliestStatusHistory.statusTo.label}
        </Text>
        <Icon
          color="accent.blue"
          name={FAIconName.arrowRightRegular}
          aria-hidden={false}
          aria-label="Changed to"
          size="sm"
        />
        <Text variant="caption" whiteSpace="nowrap">
          {intervention.statusHistories[0].statusTo.label}
        </Text>
      </ChakraFlex>
    );
  }

  return (
    <>
      <InterventionText
        categories={categories}
        data-testid={`patient-note-item__intervention-name__${intervention.id}`}
        intervention={intervention}
        variant="caption"
      />
      {statusNode}
    </>
  );
};
